import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.7_@babel+core@7.28.4_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Public_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\"}],\"variableName\":\"publicSans\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.1.6/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectionProvider"] */ "/app/src/hooks/use-connection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlaygroundStateProvider"] */ "/app/src/hooks/use-playground-state.tsx");
